export default[
    {
        path: '/webinars',
        name: 'webinars',    
        component: () => import('@/views/webinars/MasterWebinarAtelier.vue'),
    },
    
]